export enum ETipoTituloFinanceiro {
  Pagar = 1,
  Receber = 2,
}
